import axios from '@/plugins/axios';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('car_parks', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      commit('setList', enumerateArray(data.data.items));
      return data;
    } catch (error) {
      return error;
    }
  },

  async addNew(_, formData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post('car_parks', formData, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      const msg = error.response
        ? error.response.data.error.message
        : error.message;

      return { error: msg };
    }
  },

  async updateItem(_, { id, formData }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`car_parks/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      const msg = error.response
        ? error.response.data.error.message
        : error.message;

      return { error: msg };
    }
  },

  async deleteItem(_, id) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.delete(`car_parks/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });
      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async restoreItem(_, id) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.get(`car_parks/restore/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: error.message };
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
